import React, { useMemo } from 'react'
import { Box, Typography, Button, Modal } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { styles } from '../../interchanges/styles';
import { BuyerInventoryActivityReportVO } from '../../../types/model/valueObject/inventoryActivity/BuyerInventoryActivityReportVO';
import { imageRepositoryBaseURL } from '../../constants/securspace-constants';
import type { ActionDialogProps } from '../../cardComponents';

const NOT_FOUND_IMAGE = '/app-images/not-found-image/place_holder_image.png';

export interface BuyerInterchangeImageModalProps extends ActionDialogProps {
  item?: BuyerInventoryActivityReportVO;
}

const BuyerInterchangeImageModal = ({
  open,
  onClose,
  item
}: BuyerInterchangeImageModalProps) => {
  // Modal/Button pass events to their callbacks, which must not be treated as a payload.
  const handleClose = () => onClose();

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const image = e.currentTarget;
    if (!image.src.endsWith(NOT_FOUND_IMAGE)) {
      image.src = NOT_FOUND_IMAGE;
    }
  };

  const images = useMemo(() => {
    return item?.inventoryGallery ?
      item.inventoryGallery.map(galleryItem => `${imageRepositoryBaseURL}/inventory/${item.id}/${galleryItem.galleryImageFileName}`)
    : []
  }, [item]);


  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={{
        m: 2
      }}
    >
      <Box sx={styles.modalContainer} role="dialog" aria-modal="true" aria-label="View Images">
        <Box>
          <Box sx={styles.modalHeader}>
            <Typography variant="h6" sx={{
              fontWeight: 600
            }}>
              View Images
            </Typography>
            <Button aria-label="Close image viewer"
              variant="text"
              onClick={handleClose}
              color="secondary">
              <CloseIcon />
            </Button>
          </Box>

          <Box sx={styles.imageContainer}>
            {
              images && images.map((image) => (
                <Box sx={styles.image} key={image}>
                  <Box
                    component="img"
                    src={image}
                    alt="Interchange inventory"
                    loading="lazy"
                    onError={handleImageError}
                  />
                </Box>
              ))
            }
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default BuyerInterchangeImageModal
